import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Stack, SxProps, Theme } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';

interface More {
    title: string;
    icon: string;
}

interface IMore {
    onClick: (moreType: string) => void;
    menu: More[];
    sx?: SxProps<Theme>;
    typographyStyle?: React.CSSProperties;
    onIconClick?: () => void;
}

const PopOverMore: React.FC<IMore> = ({ onClick, menu, sx, typographyStyle, onIconClick }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const { themeStyle } = useThemeContext();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        onIconClick && onIconClick();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const handleOnClickHandle = (title: string) => {
        onClick && onClick(title);
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon
                    sx={{
                        color: theme[themeStyle].tag_white,
                    }}
                />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        backgroundColor: theme[themeStyle].deep_grey_lighter,
                        borderRadius: 4,
                        padding: '10px',
                        margin: '0px',
                        minWidth: '150px',
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>
                <Box
                    style={{
                        backgroundColor: theme[themeStyle].deep_grey_lighter, // Grey background color
                        padding: '8px',
                        minWidth: '150px',
                    }}>
                    {menu.map((d, i) => (
                        <Stack
                            key={i}
                            onClick={() => handleOnClickHandle(d.title)}
                            flexDirection="row"
                            my={1}
                            style={{ cursor: 'pointer' }}>
                            <CustomLazyLoadImage
                                src={d.icon}
                                alt={d.title}
                                style={{ height: '20px', width: '20px', marginRight: '10px' }}
                            />
                            <Typography sx={{ color: '#fff' }} style={typographyStyle}>
                                {d.title}
                            </Typography>
                        </Stack>
                    ))}
                </Box>
            </Popover>
        </>
    );
};

export { PopOverMore };
